import gql from 'graphql-tag';

export const CREATE_ARTICLE_FROM_CANDIDATE = gql`
  mutation AddArticleFromFeed(
    $campaignId: ID!
    $url: String!
    $action: PostActionEnum!
    $postIds: [String!]!
    $manualExpirationTime: String
    $facebookPageId: BigInt
  ) {
    addArticleFromFeed(
      campaignId: $campaignId
      url: $url
      action: $action
      postIds: $postIds
      manualExpirationTime: $manualExpirationTime
      facebookPageId: $facebookPageId
    ) {
      article {
        id
      }
      errors
    }
  }
`;
